/**
 * IBM Confidential OCO Source Materials IBM Business Platform: Glass Foundation
 * (C) Copyright IBM Corp. 2017
 *
 * The source code for this program is not published or otherwise divested of
 * its trade secrets, irrespective of what has been deposited with the U.S.
 * Copyright Office
 */
requirejs.config({
	map: {
		'*': {
			// Glass (for performance increase)
			'ba_portal/lib/@waca/baglass/js/baglass' : 'baglass',
			'ba_portal/lib/@waca/core-client' : 'baglass/core-client'
		}
	}
});
